import { c as _c } from "react/compiler-runtime";
import { Outlet } from 'react-router-dom';
import { ROUTE_KEYS } from '@/navigation/constants';
import { GuardedPageRedirect } from '@/navigation/GuardedPageRedirect';
export function AdminFormsRoutes() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <GuardedPageRedirect route={ROUTE_KEYS.ADMIN_FORMS}><Outlet /></GuardedPageRedirect>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}